import { EffectsMapObject } from "dva";
import { ReducersMapObject } from "redux";
import { freeze } from "immer";
import { CoreEffects, CoreReducers, crypt } from "@reco-m/core";
import { app } from "@reco-w/core-ui";

import { Namespaces as commonNamespaces } from "@reco-w/common-models";
import { authAccountHttpService } from "@reco-w/auth-service";

import { Namespaces } from "./common";

export namespace accountMobileModel {
    export const namespace = Namespaces.accountMobile;

    export const state: any = freeze({}, !0);

    export type StateType = typeof state;
    export const reducers: ReducersMapObject = {
        ...CoreReducers,
        initState() {
            return state;
        },
    };
    export const effects: EffectsMapObject = {
        ...CoreEffects,
        /**
         * 初始化页面
         * @param { error }
         * @param { put }
         */
        *initPage({ error }, { put }) {
            yield put({ type: "getAccountMobile", error });
        },
        /**
         * 获取当前用户手机号
         */
        *getAccountMobile({ error }, { select, put, call }) {
            try {
                yield yield put({ type: `${commonNamespaces.memberCommon}/getCertify`, isRefreshUser: true });
                const memberCommonState: any = yield select((state) => state[commonNamespaces.memberCommon]);
                const user = memberCommonState.user;
                const currentUser = user.currentUser;

                yield put({ type: "input", data: { mobile: currentUser && currentUser.mobile } });
            } catch (e) {
                yield call(error, "getAccountMobile：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },
        /**
         * 修改手机号码验证
         */
        *sendBindCode({ delay, param, failCall }, { call }) {
            const cleardelay = delay();
            try {
                if (param.password) {
                    (param.encryMode = server["rsa"]?.enable ? 1 : 0), (param.password = crypt(param.password));
                }

                yield call(authAccountHttpService.sendEditMobileCode, param);
            } catch (error) {
                failCall!(error.errmsg);
                cleardelay();
            }
        },
        /**
         * 修改手机号码
         */
        *bindMobile({ param, failCall, callback }, { call, put }) {
            try {
                yield put({ type: "showLoading" });

                yield yield put({ type: `${commonNamespaces.memberCommon}/clean` });
                // yield call(authService.bindMobile, param);
                yield call(authAccountHttpService.editMobile, param);
                yield call(callback!);
            } catch (error) {
                failCall!(error.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },
        /**
         * 快速查询用户
         */
        *getUserByMobile({ error, params }, { call, put }) {
            try {
                const result = yield call(authAccountHttpService.getSampleUser, { ...params, openPlatform: -1 });
                if (result.items.length > 0) yield put({ type: "input", data: { help: "手机号已注册！" } });
                else yield put({ type: "input", data: { validateStatus: "success", help: "", isPhoneOK: true } });
            } catch (e) {
                yield call(error, "getUserByMobile：" + e.errmsg);
            }
        },
    };
}

app.model(accountMobileModel);
